import { Plus } from "lucide-react";

export const AddPageIndicator = (props: _AddPageIndicatorProps) => {
  return (
    <div
      title="Add a section here"
      className="group cursor-pointer min-h-[22px] mb-2 flex flex-row items-center gap-2 py-0.5 px-1.5 text-[var(--surface-400)] border-[1.5px] border-dashed border-transparent rounded-[10px] transition-all hover:min-h-12 hover:justify-center hover:text-[var(--primary-600)] hover:bg-[var(--primary-50)] hover:border-[var(--primary-200)]"
      onClick={props.onClick}
    >
      <span className="flex-none w-[17px] h-[17px] rounded-full border-[1.5px] border-current flex items-center justify-center">
        <Plus size={13} strokeWidth={2.4} />
      </span>
      <span className="flex-1 h-0 border-t-[1.5px] border-dashed border-current group-hover:hidden" />
      <span className="hidden flex-none whitespace-nowrap group-hover:block text-sm font-bold">Add section</span>
    </div>
  );
};

interface _AddPageIndicatorProps {
  onClick: () => void;
}
